import React, { useState } from "react";

// libraries
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// components
import colors from "core/colors";
import OffsetGrid from "core/OffsetGrid";
import SectionContainer from "core/SectionContainer";
import LoadingSpinner from "core/LoadingSpinner";
import Form from "./Form";
import breakpoints from "core/breakpoints";
import CheckoutHeader from "subscriptions/components/CheckoutHeader";

// helpers
import { useViewport } from "js/hooks/useViewport";

// styles
import { CheckoutPageHeading } from "subscriptions/styles";

// data
import {
    initialForm,
    PRO_MONTHLY_COST,
    PRO_MONTHLY_PLAN,
    PRO_YEARLY_COST
} from "subscriptions/data";

const stripePromise = loadStripe(window._nounConfig.stripePublishable);

const NounProCheckout = ({ match }) => {
    const { planType } = match.params;
    const { browserWidth } = useViewport();
    const [showError, setShowError] = useState("");
    const [form, setForm] = useState(initialForm);

    return (
        <SectionContainer
            bgColor={colors.midnight}
            removeLeftRightPadding={browserWidth < breakpoints.beforeTablet.px}
        >
            <CheckoutPageHeading
                type="h1"
                size="xl"
                headingColor={colors.mist}
                alignment="center"
                topSpacing="none"
                bottomSpacing="4xl"
            >
                Get Started with NounPro
            </CheckoutPageHeading>
            <OffsetGrid sm={12} md={12} lg={8}>
                <SectionContainer
                    bgColor={colors.snow}
                    topSpacing="2xl"
                    bottomSpacing="2xl"
                >
                    <OffsetGrid sm={12} md={8} lg={6}>
                        <CheckoutHeader />
                        <Elements stripe={stripePromise}>
                            <Form
                                itemPrice={
                                    planType === PRO_MONTHLY_PLAN
                                        ? PRO_MONTHLY_COST
                                        : PRO_YEARLY_COST
                                }
                                showOrderSummary={false}
                                planType={planType}
                                setShowError={setShowError}
                                showError={showError}
                                setForm={setForm}
                                form={form}
                            />
                        </Elements>
                    </OffsetGrid>
                </SectionContainer>
            </OffsetGrid>
        </SectionContainer>
    );
};

export default NounProCheckout;
